import React from 'react';

export interface IMessage{
  message: string|JSX.Element;
  title?: string;
  disableButtons?: boolean;
}

// @ts-ignore
export default React.createContext<(message:IMessage) => Promise<IMessage>>();